<app-form-shell
  class="cf-shell"
  [class.pp-form-single-col]="layout === 'page'"
  [formGroup]="form"
  [title]="title"
  [layout]="layout"
  [loading]="loading"
  [missingFields]="missingFields"
  [canSave]="canSave"
  [saving]="saving"
  [saveLabel]="saveLabel"
  (save)="save()"
  (cancel)="cancel()">
  <div shellHeader class="jf-switch cf-status" *ngIf="isEdit">
    <p-inputSwitch formControlName="active" inputId="cfActive"></p-inputSwitch>
    <label for="cfActive">{{ isActive ? 'Active' : 'Not active' }}</label>
  </div>

  <app-form-section icon="pi-id-card" title="Client">
    <div class="jf-grid">
      <div class="jf-field jf-col-4" *ngIf="showCompanyField">
        <div class="jf-label"><span>Client belongs to <em>*</em></span></div>
        <app-acan-select formControlName="company" [options]="companyOptions" placeholder="Select company"></app-acan-select>
        <small class="jf-error" *ngIf="isInvalid('company')">Company is required.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Client type <em>*</em></span></div>
        <div class="jf-seg jf-seg--full" role="radiogroup" aria-label="Client type">
          <button
            type="button"
            role="radio"
            class="jf-seg__btn"
            [attr.aria-checked]="form.get('type')?.value === 'BUSINESS'"
            [class.jf-seg__btn--active]="form.get('type')?.value === 'BUSINESS'"
            (click)="setType('BUSINESS')">
            Business
          </button>
          <button
            type="button"
            role="radio"
            class="jf-seg__btn"
            [attr.aria-checked]="form.get('type')?.value === 'PERSONAL'"
            [class.jf-seg__btn--active]="form.get('type')?.value === 'PERSONAL'"
            (click)="setType('PERSONAL')">
            Personal
          </button>
        </div>
        <small class="jf-error" *ngIf="isInvalid('type')">Client type is required.</small>
      </div>
      <ng-container *ngIf="isBusiness">
        <div class="jf-field jf-col-8">
          <div class="jf-label"><span>Company name <em>*</em></span></div>
          <input class="jf-input" type="text" formControlName="companyName" />
          <small class="jf-error" *ngIf="isInvalid('companyName')">Company name is required.</small>
        </div>
        <div class="jf-field jf-col-8" formGroupName="address">
          <div class="jf-label"><span>ABN / ACN <em *ngIf="!isLead">*</em></span></div>
          <input class="jf-input" type="text" formControlName="abn" placeholder="11 or 9 digits" />
          <small class="jf-error" *ngIf="hasError('address.abn', 'required')">ABN / ACN is required.</small>
          <small class="jf-error" *ngIf="hasError('address.abn', 'abnAcn')">Enter 11 digits (ABN) or 9 digits (ACN).</small>
        </div>
      </ng-container>

      <ng-container *ngIf="form.get('type')?.value === 'PERSONAL'">
        <div class="jf-field jf-col-2">
          <div class="jf-label"><span>Title <em *ngIf="!isLead">*</em></span></div>
          <app-acan-select formControlName="title" [options]="titleOptions" placeholder="Title"></app-acan-select>
          <small class="jf-error" *ngIf="isInvalid('title')">Title is required.</small>
        </div>
        <div class="jf-field jf-col-4">
          <div class="jf-label"><span>First name <em>*</em></span></div>
          <input class="jf-input" type="text" formControlName="firstname" />
          <small class="jf-error" *ngIf="isInvalid('firstname')">First name is required.</small>
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>Last name <em>*</em></span></div>
          <input class="jf-input" type="text" formControlName="lastname" />
          <small class="jf-error" *ngIf="isInvalid('lastname')">Last name is required.</small>
        </div>
      </ng-container>

      <p class="jf-hint jf-col-12" *ngIf="!form.get('type')?.value">
        <i class="pi pi-info-circle"></i> Choose Business or Personal to fill in the client's name.
      </p>
    </div>
  </app-form-section>

  <app-form-section icon="pi-envelope" title="Company Contact Details">
    <div class="jf-grid">
      <div class="jf-field jf-col-3">
        <div class="jf-label"><span>Email <em *ngIf="!isLead">*</em></span></div>
        <input class="jf-input" type="email" formControlName="email" />
        <small class="jf-error" *ngIf="hasError('email', 'required')">Email is required.</small>
        <small class="jf-error" *ngIf="hasError('email', 'email')">Email is invalid.</small>
      </div>
      <div class="jf-field jf-col-3">
        <div class="jf-label"><span>Mobile <em *ngIf="!isLead">*</em></span></div>
        <input class="jf-input" type="text" formControlName="mobileNumber" placeholder="+61 412345678" />
        <small class="jf-error" *ngIf="hasError('mobileNumber', 'required')">Mobile is required.</small>
        <small class="jf-error" *ngIf="hasError('mobileNumber', 'pattern')">Use +61 123456789 or 0123456789.</small>
      </div>
      <div class="jf-field jf-col-3">
        <div class="jf-label"><span>Secondary email</span></div>
        <input class="jf-input" type="email" formControlName="secondaryEmail" />
        <small class="jf-error" *ngIf="hasError('secondaryEmail', 'email')">Email is invalid.</small>
      </div>
      <div class="jf-field jf-col-3">
        <div class="jf-label"><span>Phone</span></div>
        <input class="jf-input" type="text" formControlName="phoneNumber" />
        <small class="jf-error" *ngIf="hasError('phoneNumber', 'pattern')">Use +61 123456789 or 0123456789.</small>
      </div>
    </div>
  </app-form-section>

  <app-form-section icon="pi-map-marker" title="Company Address">
    <i sectionActions class="pi pi-spin pi-spinner cf-fetching" *ngIf="addressFetching" aria-label="Fetching address"></i>
    <div class="jf-grid" formGroupName="address">
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Search address <em *ngIf="!isLead">*</em></span></div>
        <div class="jf-location">
          <app-search-location-widget [type]="'component'" (searchLocationDataOnchange)="onLocationChange($event)"></app-search-location-widget>
        </div>
      </div>
      <div class="jf-field jf-col-1">
        <div class="jf-label"><span>Unit</span></div>
        <input class="jf-input" type="text" formControlName="unit" />
      </div>
      <div class="jf-field jf-col-3">
        <div class="jf-label"><span>Street <em *ngIf="!isLead">*</em></span></div>
        <input class="jf-input" type="text" formControlName="street" />
        <small class="jf-error" *ngIf="hasError('address.street', 'required')">Search or enter a street address.</small>
      </div>
      <div class="jf-field jf-col-2">
        <div class="jf-label"><span>Suburb</span></div>
        <input class="jf-input" type="text" formControlName="suburb" />
      </div>
      <div class="jf-field jf-col-1">
        <div class="jf-label"><span>State</span></div>
        <input class="jf-input" type="text" formControlName="state" />
      </div>
      <div class="jf-field jf-col-1">
        <div class="jf-label"><span>Postcode</span></div>
        <input class="jf-input" type="text" formControlName="postalCode" />
      </div>
    </div>
  </app-form-section>

  <app-form-section icon="pi-wallet" title="Billing Details">
    <div sectionActions class="jf-check">
      <p-checkbox
        [(ngModel)]="isSame"
        [ngModelOptions]="{ standalone: true }"
        [binary]="true"
        inputId="cfSame"
        (onChange)="onSameToggle()"></p-checkbox>
      <label for="cfSame">Same as client details</label>
    </div>

    <div class="jf-grid" formGroupName="billingDetails">
      <ng-container *ngIf="form.get('type')?.value === 'PERSONAL'">
        <div class="jf-field jf-col-6">
          <div class="jf-label"><span>First name</span></div>
          <input class="jf-input" type="text" formControlName="firstname" />
        </div>
        <div class="jf-field jf-col-6">
          <div class="jf-label"><span>Last name</span></div>
          <input class="jf-input" type="text" formControlName="lastname" />
        </div>
      </ng-container>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Email</span></div>
        <input class="jf-input" type="email" formControlName="email" />
        <small class="jf-error" *ngIf="hasError('billingDetails.email', 'email')">Email is invalid.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Mobile</span></div>
        <input class="jf-input" type="text" formControlName="mobileNumber" />
        <small class="jf-error" *ngIf="hasError('billingDetails.mobileNumber', 'pattern')">Use +61 123456789 or 0123456789.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Phone</span></div>
        <input class="jf-input" type="text" formControlName="phoneNumber" />
        <small class="jf-error" *ngIf="hasError('billingDetails.phoneNumber', 'pattern')">Use +61 123456789 or 0123456789.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Payment terms</span></div>
        <app-acan-select
          formControlName="paymentTerms"
          [options]="paymentTermsOptions"
          placeholder="Select payment terms">
        </app-acan-select>
      </div>
    </div>

    <div class="jf-grid" formGroupName="billingAddress">
      <div class="jf-field jf-col-2">
        <div class="jf-label"><span>Unit</span></div>
        <input class="jf-input" type="text" formControlName="unit" />
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Street</span></div>
        <input class="jf-input" type="text" formControlName="street" />
      </div>
      <div class="jf-field jf-col-3">
        <div class="jf-label"><span>Suburb</span></div>
        <input class="jf-input" type="text" formControlName="suburb" />
      </div>
      <div class="jf-field jf-col-1">
        <div class="jf-label"><span>State</span></div>
        <input class="jf-input" type="text" formControlName="state" />
      </div>
      <div class="jf-field jf-col-2">
        <div class="jf-label"><span>Postcode</span></div>
        <input class="jf-input" type="text" formControlName="postalCode" />
      </div>
    </div>

    <div class="jf-grid" formGroupName="billingDetails">
      <div class="jf-field jf-col-12">
        <div class="jf-label"><span>Billing notes</span></div>
        <textarea class="jf-input jf-textarea" rows="2" formControlName="note"></textarea>
      </div>
    </div>
  </app-form-section>

  <app-form-section icon="pi-briefcase" title="Projects">
    <div class="jf-grid">
      <div class="jf-field jf-col-6">
        <div class="jf-label"><span>Project name</span></div>
        <input class="jf-input" type="text" formControlName="project" />
        <p class="jf-hint">Optional. You can add more projects from the client profile.</p>
      </div>
    </div>
  </app-form-section>

  <app-form-section *ngIf="isBusiness" icon="pi-users" title="Contact person">
    <div class="jf-grid" formGroupName="contactPerson">
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>First name <em>*</em></span></div>
        <input class="jf-input" type="text" formControlName="firstname" />
        <small class="jf-error" *ngIf="hasError('contactPerson.firstname', 'required')">First name is required.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Last name <em>*</em></span></div>
        <input class="jf-input" type="text" formControlName="lastname" />
        <small class="jf-error" *ngIf="hasError('contactPerson.lastname', 'required')">Last name is required.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Job position</span></div>
        <input class="jf-input" type="text" formControlName="jobPosition" />
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Email <em *ngIf="!isLead">*</em></span></div>
        <input class="jf-input" type="email" formControlName="email" />
        <small class="jf-error" *ngIf="hasError('contactPerson.email', 'required')">Email is required.</small>
        <small class="jf-error" *ngIf="hasError('contactPerson.email', 'email')">Email is invalid.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Mobile <em *ngIf="!isLead">*</em></span></div>
        <input class="jf-input" type="text" formControlName="mobile" />
        <small class="jf-error" *ngIf="hasError('contactPerson.mobile', 'required')">Mobile is required.</small>
        <small class="jf-error" *ngIf="hasError('contactPerson.mobile', 'pattern')">Use +61 123456789 or 0123456789.</small>
      </div>
      <div class="jf-field jf-col-4">
        <div class="jf-label"><span>Phone</span></div>
        <input class="jf-input" type="text" formControlName="phoneNumber" />
        <small class="jf-error" *ngIf="hasError('contactPerson.phoneNumber', 'pattern')">Use +61 123456789 or 0123456789.</small>
      </div>
    </div>
  </app-form-section>

  <app-form-section icon="pi-paperclip" title="Notes & files">
    <div class="jf-grid">
      <div class="jf-field jf-col-12 jf-editor">
        <div class="jf-label"><span>Notes</span></div>
        <p-editor formControlName="additionalNote" [style]="{ height: '120px' }">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
          </ng-template>
        </p-editor>
      </div>
      <div class="jf-field jf-col-12 jf-attachments">
        <p-fileUpload
          #uploader
          mode="basic"
          chooseLabel="Attach file"
          chooseIcon="pi pi-paperclip"
          accept=".zip,.pdf,.doc,.docx,.xls,.xlsx,image/*"
          [auto]="true"
          [customUpload]="true"
          [disabled]="attachmentUploading"
          (uploadHandler)="onAttachmentUpload($event, uploader)"></p-fileUpload>
        <i class="pi pi-spin pi-spinner" *ngIf="attachmentUploading" aria-label="Uploading"></i>
        <span class="jf-file" *ngFor="let file of attachments; let i = index">
          <file-icon [type]="fileIcon(file.originalFileName)"></file-icon>
          <a [href]="file.url" target="_blank" rel="noopener">{{ file.originalFileName || 'File' }}</a>
          <button type="button" (click)="openRename(i)" aria-label="Rename attachment"><i class="pi pi-pencil"></i></button>
          <button type="button" (click)="removeAttachment(i)" aria-label="Remove attachment"><i class="pi pi-times"></i></button>
        </span>
      </div>
    </div>
  </app-form-section>
</app-form-shell>

<p-confirmDialog key="clientFormUpdate" header="Confirmation" appendTo="body"></p-confirmDialog>
<p-confirmDialog key="clientFormRemoveFile" header="Confirmation" appendTo="body"></p-confirmDialog>

<p-dialog
  header="Rename attachment"
  [(visible)]="renameDialog"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  styleClass="jf-dialog"
  [style]="{ width: '420px' }"
  [breakpoints]="{ '600px': '94vw' }">
  <form [formGroup]="renameForm" class="jf-dialog-grid">
    <div class="jf-field jf-dialog-grid__full">
      <div class="jf-label"><span>File name <em>*</em></span></div>
      <div class="cf-rename">
        <input class="jf-input" type="text" formControlName="fileName" />
        <input class="jf-input cf-rename__ext" type="text" formControlName="fileExtension" />
      </div>
      <small class="jf-error" *ngIf="renameForm.get('fileName')?.errors?.['required']">File name is required.</small>
      <small class="jf-error" *ngIf="renameForm.get('fileName')?.errors?.['invalidChars']">Don't use "." or "/".</small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="jf-btn" (click)="renameDialog = false">Cancel</button>
    <button type="button" class="jf-btn jf-btn--primary" [disabled]="renameForm.invalid" (click)="saveRename()">Save</button>
  </ng-template>
</p-dialog>
